import { render, staticRenderFns } from "./notificationCenter.vue?vue&type=template&id=3982ad70&scoped=true&"
import script from "./notificationCenter.vue?vue&type=script&lang=js&"
export * from "./notificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./notificationCenter.vue?vue&type=style&index=0&id=3982ad70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982ad70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
